import './style/index.js';

import _Link from './link';

export type { LinkProps } from './link';

export const Link = _Link;

export default Link;
